import { FC } from 'react';

import * as Form from 'components/_core/form';

interface InvoicingPaymentLateFeeInputProps {
  value: number;
  onChange: (value: number | string) => void;
  minLatePaymentFee: number;
}
const InvoicingPaymentLateFeeInput: FC<InvoicingPaymentLateFeeInputProps> = ({
  onChange,
  value,
}) => (
  <Form.Input
    onChange={({ target }) =>
      onChange(target.value === '' ? target.value : Number(target.value))
    }
    type="number"
    value={value}
  />
);

export default InvoicingPaymentLateFeeInput;
